import React, { useEffect, useState } from "react";
import DecadeNavBarDesktop from "./DecadeNavBarDesktop";
import DecadeNavBarMobile from "./DecadeNavBarMobile";

const MOBILE_DECADE_BREAKPOINT = 768;

export default function DecadeNavBar(props) {
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth <= MOBILE_DECADE_BREAKPOINT
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_DECADE_BREAKPOINT);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? (
    <DecadeNavBarMobile {...props} />
  ) : (
    <DecadeNavBarDesktop {...props} />
  );
}
